const SignUploadIcon = () => {
  return (
    <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 24.42V8.12L8.8 13.32L6 10.42L16 0.419998L26 10.42L23.2 13.32L18 8.12V24.42H14ZM4 32.42C2.9 32.42 1.95833 32.0283 1.175 31.245C0.391667 30.4617 0 29.52 0 28.42V22.42H4V28.42H28V22.42H32V28.42C32 29.52 31.6083 30.4617 30.825 31.245C30.0417 32.0283 29.1 32.42 28 32.42H4Z"
        fill="#6E6E6E"
      />
    </svg>
  );
};

export default SignUploadIcon;
